import { createAction } from '@reduxjs/toolkit';

export const REMOVE_INCOMING_CALL_ACTION_TYPE = 'saga/removeIncomingCall';
export const removeIncomingCallAction = createAction(REMOVE_INCOMING_CALL_ACTION_TYPE);
